/**
 * Shared styles for filter drawer forms (the inner form layout, root padding, and footer).
 * Used by OrdersFilter, PaymentsFilter, and any future filter drawers.
 */
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useFilterStyles = createStyles({
  root: {
    padding: `0 ${tokens.spacing[6]}`,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[4],
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: tokens.spacing[6],
    gap: tokens.spacing[2],
  },
});
